import { updateMobileMap } from './updateMobileMap';
import { updateDesktopMap } from './updateDesktopMap';

/**
 * Activate a station
 */

export function selectStation(ref, station, isMobile) {
  resetStation(ref, isMobile);
  activateStation(station, isMobile);
}

// export function selectStationMobile(ref, station) {
//   resetStationMobile(ref);
//   activateStationMobile(station);
// }

export function resetStation(ref, isMobile) {
  const activeStation = ref.querySelectorAll('#stations > g.active');
  if (activeStation?.length) {
    activeStation.forEach((el) => {
      const use = el.querySelector('use');
      use?.setAttribute('href', '#circle-add');

      el.classList.remove('active');

      const paths = el.querySelectorAll('path, circle');
      paths.forEach((path) => {
        // active station selection
        path.classList.add('fill-white');
        path.classList.remove('stroke-eucalyptus');
        path.classList.remove('fill-eucalyptus');
        // area active selection
        path.classList.remove('fill-warm-grey');
        path.classList.remove('stroke-warm-grey');
      });
    });
  }
}

export function activateStation(el, isMobile) {
  if (!el) return;
  el.classList.add('active');

  const use = el.querySelector('use');
  use?.setAttribute('href', '#circle-close');

  const paths = el.querySelectorAll('path, circle');
  paths.forEach((path) => {
    path.classList.remove('fill-white');
    path.classList.add('fill-eucalyptus');
    path.classList.add('stroke-eucalyptus');
    path.style.fillOpacity = '1';
    path.setAttribute('opacity', '1');
  });
}

export function resetStationMobile(ref) {
  const activeStation = ref.querySelectorAll('#stations-mobile > g.active');
  if (activeStation?.length) {
    activeStation.forEach((el) => {
      const use = el.querySelector('use');
      use?.setAttribute('href', '#circle-adds');

      el.classList.remove('active');

      const paths = el.querySelectorAll('path, circle');
      paths.forEach((path) => {
        // active station selection
        path.classList.add('fill-white');
        path.classList.remove('stroke-eucalyptus');
        path.classList.remove('fill-eucalyptus');
        // area active selection
        path.classList.remove('fill-warm-grey');
        path.classList.remove('stroke-warm-grey');
      });
    });
  }
}

export function activateStationMobile(el) {
  if (!el) return;
  el.classList.add('active');

  const use = el.querySelector('use');
  use?.setAttribute('href', '#circle-close-mobile');

  const paths = el.querySelectorAll('path, circle');
  paths.forEach((path) => {
    path.classList.remove('fill-white');
    path.classList.add('fill-eucalyptus');
    path.classList.add('stroke-eucalyptus');
    path.style.fillOpacity = '1';
    path.setAttribute('opacity', '1');
  });
}

export function activateStationsInCategory(ref, { categoryId, stationId }) {
  if (!categoryId || stationId) return;

  resetStation(ref);
  const activeStation = ref.querySelectorAll(`#stations > g.${categoryId}`);
  const activeStationMobile = ref.querySelectorAll(`#stations-mobile > g.${categoryId}`);
  if (activeStation?.length) {
    activeStation.forEach((el) => {
      const use = el.querySelector('use');
      use?.setAttribute('href', '#circle-add');

      el.classList.add('active');

      const paths = el.querySelectorAll('path, circle');
      paths.forEach((path) => {
        path.classList.remove('fill-white');
        path.classList.add('fill-warm-grey');
        path.classList.add('stroke-warm-grey');
        path.style.fillOpacity = '1';
        path.setAttribute('opacity', '1');
      });
    });
  }
  if (activeStationMobile?.length) {
    activeStationMobile.forEach((el) => {
      const use = el.querySelector('use');
      use?.setAttribute('href', '#circle-adds');

      el.classList.add('active');

      const paths = el.querySelectorAll('path, circle');
      paths.forEach((path) => {
        path.classList.remove('fill-white');
        path.classList.add('fill-warm-grey');
        path.classList.add('stroke-warm-grey');
        path.style.fillOpacity = '1';
        path.setAttribute('opacity', '1');
      });
    });
  }
}

/**
 * Update selected areas (category) color & reset
 */

export function activateArea(ref, { categoryId, stationId }) {
  // 1. update areas color
  const areas = ref.querySelectorAll('#areas > g');
  if (!areas.length) return;

  areas.forEach((area) => {
    const ellipse = area.querySelector('ellipse,circle');
    if (!ellipse) return;

    // reset all class
    area.classList.remove(...area.classList);
    ellipse.classList.remove(...ellipse.classList);

    if (area.id !== `area-${categoryId}` || stationId) return;

    // update active class
    area.classList.add('active');
    ellipse?.classList.add('fill-warm-grey/15');
    ellipse?.classList.add('stroke-white');
  });

  // 2. update pins color
  const pins = ref.querySelectorAll('#category-pins > g');
  if (!pins.length) return;

  pins.forEach((pin) => {
    const dialog = pin.querySelector('.pin-dialog');
    const logo = pin.querySelectorAll('.pin-logo > path');
    const text = pin.querySelector('.pin-text');

    // update inactive pin
    const isInactivePin = Boolean(stationId) || pin.id !== categoryId;
    if (isInactivePin) {
      dialog.setAttribute('fill', '#3B3727');
      text.setAttribute('fill', 'white');
      logo.forEach((l) => l.setAttribute('stroke', 'white'));
      return;
    }

    // update active pin
    dialog.setAttribute('fill', 'white');
    text.setAttribute('fill', '#3B3727');
    logo.forEach((l) => l.setAttribute('stroke', '#3B3727'));
  });
}

/**
 * Update map scale & positionXY
 */

export function changeMapPosition(
  ref,
  { categoryId, isMobile, stationId, desktopSizePosition }
) {
  activateArea(ref, { categoryId, stationId });

  if (isMobile) {
    return updateMobileMap(ref, { stationId, categoryId });
  }
  return updateDesktopMap(ref, { stationId, categoryId, desktopSizePosition });
}
